import { BRAND, SISTER_CONCERNS } from "../lib/constants";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-[#FDFBF7] py-20 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          {/* Logo column */}
          <div className="lg:col-span-4 reveal flex justify-center lg:justify-start">
            <img
              src={BRAND.logo}
              alt="Sardaar Stevedoring Pvt. Ltd."
              className="w-64 md:w-80 lg:w-full max-w-sm h-auto object-contain"
              data-testid="about-logo"
            />
          </div>

          {/* Text column */}
          <div className="lg:col-span-8 reveal" style={{ transitionDelay: "100ms" }}>
            <div className="flex items-center gap-4 mb-8">
              <span className="gold-line" />
              <span
                className="font-sans text-[#0B2545] uppercase text-base md:text-lg tracking-widest-2 font-semibold"
                data-testid="about-overline"
              >
                Our Heritage
              </span>
            </div>

            <h2 className="font-serif text-[#0B2545] text-4xl md:text-5xl lg:text-6xl font-semibold leading-[1.05] tracking-tight">
              A name shaped by{" "}
              <em className="not-italic text-[#C8A24A]">five decades</em> of
              cargo across Eastern India.
            </h2>

            <div className="mt-10 space-y-6 font-sans text-[#061426]/90 text-base md:text-lg leading-relaxed">
              <p>
                Sardaar Stevedoring Pvt. Ltd. is a venture born from the same
                roots as <strong className="text-[#0B2545]">Sardar Roadlines</strong>,{" "}
                <strong className="text-[#0B2545]">Mahavir Transport</strong> and{" "}
                <strong className="text-[#0B2545]">Nayak and Associates</strong>.
                From a humble background, our late patriarch{" "}
                <strong className="text-[#0B2545]">Late Shri Narahari Nayak</strong>
                {" "}— fondly and respectfully remembered in the industry as{" "}
                <em className="text-[#C8A24A]">Nari Sardar</em> — commenced
                business in 1970 with Sardar Roadlines, and went on to build a
                clutch of enterprises that became cornerstones of cargo handling
                in the region.
              </p>
              <p>
                His operational discipline, reliability and contribution to
                organised road transportation were appreciated by esteemed
                leaders such as Late Shri Janaki Ballabh Patnaik and Late Shri
                Biju Patnaik — a recognition our family continues to cherish.
              </p>
              <p>
                Today, Sardaar Stevedoring Pvt. Ltd. is led by the{" "}
                <strong className="text-[#0B2545]">
                  second and third generations
                </strong>{" "}
                of the family — carrying that same discipline to the quayside.
              </p>
            </div>

            <div className="mt-12 pt-8 border-t border-[#0B2545]/10">
              <div className="font-sans text-xs uppercase tracking-widest-2 text-[#0B2545]/60 mb-3">
                Group of Companies
              </div>
              <div className="flex flex-wrap gap-x-6 gap-y-2">
                {SISTER_CONCERNS.map((c) => (
                  <span
                    key={c}
                    data-testid={`sister-concern-${c}`}
                    className="font-serif text-[#0B2545] text-lg italic"
                  >
                    · {c}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
